<template>
    <div class="news_photo dirr">
        <div class="news_con d-sm-flex">
            <div class="most" v-if="mostNews_skeleton"> 
                <v-layout row>
                    <v-skeleton-loader v-bind="attrs" type="text@1" height="10" max-width="325" style="top:10px" ></v-skeleton-loader>
                </v-layout>
                
                <hr>
                <v-layout row>
                    <v-flex lg12 style="padding:0 "> <v-skeleton-loader width="100%" height="200" type="image"></v-skeleton-loader> </v-flex>
                </v-layout>
                <div class="button-section">
                    <div class="button-container d-flex">
                    <v-skeleton-loader style="margin: 20px;" type="button"></v-skeleton-loader>
                    <v-skeleton-loader style="margin: 20px;" type="button"></v-skeleton-loader>
                    <v-skeleton-loader style="margin: 20px;" type="button"></v-skeleton-loader>
                    </div>
                </div>
                <v-layout>
                    <v-flex sm12 md6 lg4 style="padding:0 10px;"><v-skeleton-loader  height="180" type="image"></v-skeleton-loader></v-flex>
                    <v-flex sm12 md6 lg4 style="padding:0 10px;"><v-skeleton-loader  height="180" type="image"></v-skeleton-loader></v-flex>
                    <v-flex sm12 md6 lg4 style="padding:0 10px;"><v-skeleton-loader  height="180" type="image"></v-skeleton-loader></v-flex> 
                </v-layout>


            </div>
            <template v-else>

                <div class="title mx-2"  style=" display:flex">
                    <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                    <p class="tl" style="font-size: 24px; padding: 0 15px;">{{ $t("Picture_Reports") }}</p>
                </div>
                <v-container fluid class="breadcrumb-container" :style="{ backgroundImage: `url(${isMobile && mob_img ? mob_img : main_img})` }">
                    <v-row>
                    <v-col cols="12">
                        <v-breadcrumbs>
                        
                        </v-breadcrumbs>
                    </v-col>
                    </v-row>
                </v-container>
             
                <div class="my-1"></div>
            
                <div :class="{'infograph-section-dark': $vuetify.theme.dark , 'infograph-section': !$vuetify.theme.dark}">
                    
                    <!-- <div class="title infograph-section-title mx-2"  style=" display:flex">
                        <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                        <p class="tl" style="font-size: 24px; padding: 0 15px;">{{ $t("Picture_Reports") }}</p>
                    </div> -->

                    <div class="infograph-highlight-slider">
                        <swiper class="infograph-swiper" :options="highlightSwiperOptions">
                        <swiper-slide class="infograph-highlight-item" v-for="(card, cardIndex) in sliderCards" :key="cardIndex">
                            <span class="stack-layer stack-layer-1">
                                <span class="stack-layer-inner" :style="stackLayerStyle(card)"></span>
                            </span>
                            <span class="stack-layer stack-layer-2">
                                <span class="stack-layer-inner" :style="stackLayerStyle(card)"></span>
                            </span>
                            <div class="infograph-card">
                                <div class="video-wrapper full-height" v-if="card.video_file">
                                    <router-link :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale">
                                        <video muted :poster="'https://alkafeel.net/news/images/main/370/' + card.image" :src="'https://alkafeel.net/news/images/infograph/'+card.video_file" class="image-hover-scale full-height-img video-container"></video>
                                    </router-link>
                                    <button class="play-btn" @click="togglePlay">
                                        <span class="play-icon">▶</span>
                                    </button>
                                </div>
                                <router-link v-else :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale" class="item full-height">
                                    <img :src="highlightImage(card)" class="image-hover-scale full-height-img">
                                </router-link>
                            </div>
                        </swiper-slide>
                        </swiper>
                    </div>
                </div>

                <div class="my-1"></div>

                <div class="button-section w-100">
                    <div class="button-container d-flex scroll-horizontal">
                        <v-btn :class="['custom-button', 'mx-2', { 'custom-button-active': String(cat_id) === '0' }]" @click="info_all()">
                            <img :class="['button-icon', { 'button-icon-dark': $vuetify.theme.dark && String(cat_id) !== '0', 'button-icon-active': String(cat_id) === '0' }]" :src="'/assets/img/tab-all.png'" />
                            <span :class="{ 'custom-button-text-active': String(cat_id) === '0' }" :style="$vuetify.theme.dark && String(cat_id) !== '0' ? 'color:#FFF' : ''"> الكل </span>
                        </v-btn>

                        <template v-for="(cat, catIndex) in cats">
                            <v-btn :class="['custom-button', 'mx-2', { 'custom-button-active': String(cat_id) === String(cat.req) }]" @click="info_cat(cat.req)">
                                <img :src="cat.icon" :class="['button-icon', { 'button-icon-dark': $vuetify.theme.dark && String(cat_id) !== String(cat.req), 'button-icon-active': String(cat_id) === String(cat.req) }]" />
                                <span :class="{ 'custom-button-text-active': String(cat_id) === String(cat.req) }" :style="$vuetify.theme.dark && String(cat_id) !== String(cat.req) ? 'color:#FFF' : ''">{{ cat.title }}</span>
                            </v-btn>
                        </template>
                        
                    </div>
                </div>

                <div class="mt-5"></div>
                <hr>

                <v-container ref="cardsSection">
                    <v-row class="inf"> 
                        <template v-if="catLoading">
                            <v-col v-for="item in 6" :key="'cat-skeleton-' + item" cols="12" md="6" lg="4" style="margin-bottom: 50px;">
                                <v-skeleton-loader type="image" height="260"></v-skeleton-loader>
                            </v-col>
                        </template>

                        <template v-else>
                            <v-col v-for="(card, cardIndex) in cards" :key="cardIndex" cols="12" md="6" lg="4" style="margin-bottom: 50px;">
                                <transition name="fade">
                                    <div class="video-wrapper" v-if="card.video_file">
                                        <router-link  :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale">
                                            <video @mouseenter="playVideo" @mouseleave="pauseVideo" @touchstart="playVideo" @touchend="pauseVideo" muted :poster="'https://alkafeel.net/news/images/main/370/' + card.image" :src="'https://alkafeel.net/news/images/infograph/'+card.video_file" class="image-hover-scale full-height-img video-container" ></video>
                                        </router-link>
                                        <button v-if="!isPlaying" class="play-btn" @click="togglePlay">
                                            <span class="play-icon">{{ isPlaying ? '❚❚' : '▶' }}</span>
                                        </button>
                                    </div>

                                    <v-carousel v-else :cycle="activeIndex === cardIndex ? true : false" interval="3000" :show-arrows="false">
                                        <v-carousel-item v-for="(image, i) in [card.image, ...card.images]" :key="i">
                                            <router-link :to="'/new/infograph_inner/'+ card.id + '?&lang=' +$i18n.locale" class="item">
                                                <img :src="image.includes('http') ? image : 'https://alkafeel.net/news/images/main/370/' + image" class="image-hover-scale full-height-img">
                                            </router-link>
                                        </v-carousel-item>
                                    </v-carousel>
                                </transition>
                            </v-col>
                        </template>

                        <div class="mx-auto pagination-wrapper" v-if="pageCount > 1 && !catLoading">
                            <v-pagination
                                class="pagination"
                                v-model="page"
                                :length="pageCount"
                                :total-visible="7"
                                color="rgba(177, 189, 82, 1)"
                                @input="changePage"
                            ></v-pagination>
                        </div>
                    </v-row>


                </v-container>
            </template>


            


        </div>
      
    </div>
    </template> 
    
    <script>
    import searchVue from './search.vue';
    export default {
        data() {
            return {
                activeIndex: 0,
                mostNews : [{"id":"","title":"","image":"", "images":[]}],
                News : [{"id":"","title":"","image":""}],
                picNews : [],
                mostNews_skeleton : true,
                NewsPage : 1,
                page: 1,
                pageCount: 0,
                current_page: 1,
                last_page: 0,
                getMorenews : true,
                shouldScrollToCards: false,
                catLoading: false,
                loader: null,
                loading: false,
                axios_load: false,
                cats: [
                    {"req":"0","title":"الكل","icon":"/assets/img/tab-all.png"},
                    {"req":"1","title":"انفوغراف","icon":"/assets/img/tab-infographic.png"},
                    {"req":"2","title":"صور متعددة","icon":"/assets/img/tab-multi-photos.png"},
                    {"req":"3","title":"موشن جرافيك","icon":"/assets/img/tab-motion-graphic.png"},
                    {"req":"4","title":"بوست","icon":"/assets/img/tab-post.png"},
                ],
                cat_id: 0,
                visibleCards: [],
                main_img: '',
                mob_img: '',
                cardTime: 3000,
                attrs: {
                    class: 'mb-6',
                    boilerplate: false,
                    elevation: 2,
                },
                isMobile: false,
                highlightSwiperOptions: {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    spaceBetween: 16,
                    grabCursor: true,
                    breakpoints: {
                        // 480: { slidesPerView: 2, spaceBetween: 18 },
                        // 768: { slidesPerView: 2.8, spaceBetween: 20 },
                        // 1024: { slidesPerView: 3.5, spaceBetween: 24 },
                        // 1264: { slidesPerView: 4.2, spaceBetween: 28 },

                        480: { slidesPerView: 2, spaceBetween: 18 },
                        768: { slidesPerView: 3.4, spaceBetween: 20 },
                        1024: { slidesPerView: 4.2, spaceBetween: 24 },
                        1264: { slidesPerView: 5, spaceBetween: 28 },
                    },
                },
                sliderCards: [
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                ],
                cards: [
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                    { image: '', images: ["https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg", "https://alkafeel.net/news/images/main/ebd7be965db5b361da3c3e13aa0d6482.jpg"] },
                ],
                isPlaying: false,
            }
        },
        watch: {
            loader () {
                const l = this.loader
                this[l] = !this[l]
                setTimeout(() => (this[l] = false), 2000)
                this.loader = null
            }
        },
        components: {
            'news-search': searchVue
        },
        directives: {},
        computed: {},
        mounted() {
            // this.initPlayer();
            this.checkIfMobile();
            window.addEventListener('resize', this.checkIfMobile);
            document.title =this.$t("Picture_Reports");
            this.$el.addEventListener('click', this.handleHighlightCardClick, true);
            window.addEventListener('popstate', this.handlePopState);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkIfMobile);
            this.$el.removeEventListener('click', this.handleHighlightCardClick, true);
            window.removeEventListener('popstate', this.handlePopState);
        },
        created () {
            const routeState = this.getRouteState();
            this.cat_id = routeState.cat;
            this.page = routeState.page;
            this.current_page = routeState.page;
            this.NewsPage = routeState.page;
            this.loadCats();
            // this.getmostNews();
            this.infograph_img();
            this.loadSlider();
            this.grtpicNews();
        },
        methods:{
            playVideo(event) {
                const video = event.target;
                video.play();
                this.isPlaying = true; // Update state to playing
            },
            pauseVideo(event) {
                const video = event.target;
                video.pause();
                this.isPlaying = false; // Update state to paused
            },
            handleHighlightCardClick(event) {
                const card = event.target.closest('.infograph-card');
                if (!card) {
                    return;
                }
                const slide = card.closest('.swiper-slide');
                if (!slide || slide.classList.contains('swiper-slide-active')) {
                    return;
                }
                event.preventDefault();
                const swiperEl = card.closest('.swiper-container');
                const swiperInstance = swiperEl && swiperEl.swiper;
                const realIndex = Number(slide.getAttribute('data-swiper-slide-index'));
                if (swiperInstance && !Number.isNaN(realIndex)) {
                    swiperInstance.slideToLoop(realIndex);
                }
            },
            togglePlay(event) {
                const slide = event.target.closest('.swiper-slide');
                if (slide && !slide.classList.contains('swiper-slide-active')) {
                    return;
                }
                const video = event.target.closest('.video-wrapper').querySelector('video');
                if (video.paused) {
                video.play();
                this.isPlaying = true; // Update state to playing
                } else {
                video.pause();
                this.isPlaying = false; // Update state to paused
                }
            },
            updatePlayIcon(event) {
                const video = event.target;
                this.isPlaying = !video.paused; // Sync state with video's playback state
            },
            nextSlide() {
                if ( this.cards[this.activeIndex+1] !== undefined && Array.isArray(this.cards[this.activeIndex+1].images) ) {
                    this.activeIndex++;
                    this.cardTime = (this.cards[this.activeIndex].images.length * 3000) + 2000;
                } else {
                    this.activeIndex = 0;
                }
                setTimeout(this.startAutoplay, 1000);
            },
            startAutoplay() {
                if (this.activeIndex === 0) {
                    this.cardTime = (this.cards[0].images.length * 3000) + 2000;
                }
                setTimeout(this.nextSlide, this.cardTime);
            },
            checkIfMobile() {
                this.isMobile = window.innerWidth <= 468;
            },
            highlightImage(card) {
                const image = card.image || (card.images && card.images[0]) || '';
                return image.includes('http') ? image : 'https://alkafeel.net/news/images/main/370/' + image;
            },
            stackLayerStyle(card) {
                return {
                    backgroundImage: 'linear-gradient(rgba(0,0,0,.18), rgba(0,0,0,.18)), url(' + this.highlightImage(card) + ')',
                };
            },
            getRouteState() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const page = parseInt(urlParams.get('page'), 10);
                const cat = urlParams.get('cat');

                return {
                    page: Number.isFinite(page) && page > 0 ? page : 1,
                    cat: cat !== undefined && cat !== null && cat !== '' ? cat : 0,
                };
            },
            updateRouteState() {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('lang', this.$i18n.locale);
                urlParams.set('page', String(this.page));

                if (String(this.cat_id) === '0') {
                    urlParams.delete('cat');
                } else {
                    urlParams.set('cat', String(this.cat_id));
                }

                const queryString = urlParams.toString();
                const nextUrl = queryString ? (window.location.pathname + '?' + queryString) : window.location.pathname;
                window.history.pushState({}, '', nextUrl);
            },
            handlePopState() {
                const routeState = this.getRouteState();
                if (String(routeState.cat) === String(this.cat_id) && routeState.page === this.page) {
                    return;
                }

                this.cat_id = routeState.cat;
                this.page = routeState.page;
                this.current_page = routeState.page;
                this.NewsPage = routeState.page;
                this.catLoading = true;
                this.grtpicNews();
            },
            info_all () {
                this.cat_id = 0;
                this.catLoading = true;
                this.cards = [{"id":"","title":"","image":"", "images":[]}];
                this.page = 1;
                this.current_page = 1;
                this.NewsPage = 1;
                this.shouldScrollToCards = false;
                this.updateRouteState();
                this.grtpicNews();
            },
            info_cat (id) {
                this.cat_id = id;
                this.catLoading = true;
                this.cards = [{"id":"","title":"","image":"", "images":[]}];
                this.page = 1;
                this.current_page = 1;
                this.NewsPage = 1;
                // Filtering should leave the category tabs in view.
                this.shouldScrollToCards = false;
                this.updateRouteState();
                this.grtpicNews();
            },
            changePage () {
                if (this.current_page <= this.last_page || this.last_page === 0) {
                    this.current_page = this.page;
                    this.NewsPage = this.page;
                    this.shouldScrollToCards = true;
                    this.updateRouteState();
                    this.grtpicNews();
                }
            },
            loadCats() {
                this.$axios.get("articles/GetInfographCats/6")
                .then(data => {
                    this.cats = data.data;
                })
            },
            getmostNews () {
                this.$axios.get("articles/Getphotonews/5?page=1", {
                })
                .then(res => {
                    // this.NewsPage ++;
                    this.News = res.data.data;
                    // this.grtpicNews();
                    setTimeout(() => this.mostNews_skeleton = false, 500);
                    //console.log(res.data);
                })
                .catch(() => {
                });
            },
            loadSlider () {
                this.$axios.get("articles/GetInfographSlider")
                .then(data => {
                    this.sliderCards = data.data.data || data.data;
                })
            },
            infograph_img () {
                this.$axios.get("articles/infograph_img")
                .then(data => {
                    this.main_img = data.data.image;
                    this.mob_img = data.data.mobile;
                })
            },
            grtpicNews () {
                this.axios_load = true;
                this.loader = 'loading';
                this.$axios.get("articles/GetInfograph/12/"+this.cat_id+"?page=" + this.page, {
                })
                .then(res => {
                    const responseData = res.data && res.data.data && Array.isArray(res.data.data)
                        ? res.data
                        : (res.data.data || {});
                    const pagedCards = Array.isArray(res.data.data)
                        ? res.data.data
                        : (responseData.data || []);

                    this.axios_load = false;
                    this.mostNews_skeleton = false
                    this.catLoading = false;
                    this.cards = pagedCards;
                    this.last_page = res.data.last_page || responseData.last_page || 1;
                    this.pageCount = this.last_page;
                    this.current_page = this.page;
                    this.NewsPage = this.page;
                    this.getMorenews = this.page < this.last_page;
                    if (this.shouldScrollToCards && this.$refs.cardsSection) {
                        this.$nextTick(() => {
                            const cardsTop = this.$refs.cardsSection.getBoundingClientRect().top + window.pageYOffset - 200;
                            window.scrollTo({
                                top: cardsTop,
                                behavior: 'smooth',
                            });
                            this.shouldScrollToCards = false;
                        });
                    }
                    this.startAutoplay();
                })
                .catch(() => {
                    this.axios_load = false;
                    this.mostNews_skeleton = false;
                    this.catLoading = false;
                    this.shouldScrollToCards = false;
                })
            },
        },
        filters: {
            subStrArtTitle: function (string) {if (string != null) {return string.substring(0, 24) + '...';}},
            subStrlastNewsitle: function (string) {if (string != null) {return string.substring(0, 130) + '...';}},
        },
    }

    </script>
<style>

.full-height-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
}
.video-container {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}
.full-height-img:hover {
    transform: scale(1.05);
}


.video-wrapper {
  position: relative;
  display: inline-block;
}

.breadcrumb-container {
  background-size: cover;
  background-position: center;
  height: 250px;
}
.v-breadcrumbs {
  margin: 0;
}

.full-height {
    display: block;
    width: 100%;
    height: 100%;
}

.infograph-section {
    width: 100vw;
    margin-inline: calc(50% - 50vw);
    padding: 40px 0 56px;
    background-image: url('/assets/img/info-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.infograph-section-dark {
    width: 100vw;
    margin-inline: calc(50% - 50vw);
    padding: 40px 0 56px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #252525;
}

.infograph-section-title {
    padding-inline: max(0px, calc((100vw - 1275px) / 2));
    box-sizing: border-box;
}

.infograph-highlight-slider {
    width: 100%;
    margin-top: 8px;
    overflow-x: hidden;
}

.infograph-swiper {
    width: 100%;
    padding: 12px 0 16px;
}

.infograph-swiper .infograph-highlight-item {
    height: auto;
    min-height: 0;
    align-self: flex-start;
    overflow: visible;
    position: relative;
    box-sizing: border-box;
    transform: scale(0.65);
    filter: blur(2px);
    opacity: 0.7;
    transition: transform 0.45s ease, filter 0.45s ease, opacity 0.45s ease;
}

.infograph-swiper .infograph-highlight-item::before {
    content: '';
    display: block;
    padding-top: 133.333333%;
}

.infograph-swiper .infograph-highlight-item.swiper-slide-active {
    transform: scale(1);
    filter: blur(0);
    opacity: 1;
    z-index: 2;
}

.infograph-highlight-item .stack-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 6%;
    right: 6%;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    opacity: 0.8;
    z-index: 0;
}

.infograph-highlight-item .stack-layer-inner {
    position: absolute;
    inset: -12px;
    background-size: cover;
    background-position: center;
    filter: blur(8px);
}

.infograph-highlight-item .stack-layer-1 {
    transform: translateY(-4px);
}

.infograph-highlight-item .stack-layer-2 {
    transform: translateY(4px);
}

.infograph-highlight-item .infograph-card {
    position: absolute;
    top: 6px;
    right: 0;
    bottom: 6px;
    left: 0;
    z-index: 1;
    width: 100%;
    height: auto;
    margin: 0;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.play-btn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.play-icon {
  margin-left: 4px;
}





.inf .v-carousel {
    overflow:visible
}
.inf .video-wrapper {
    display: block;
    width: 100%;
    height: 500px;
    overflow: hidden;
}
.inf .video-wrapper > a {
    display: block;
    width: 100%;
    height: 100%;
}
.inf .video-wrapper .video-container {
    object-fit: cover;
}
.inf .v-carousel__controls .v-icon {
    font-size: 8px;
}
.inf .v-carousel__controls {
    position: relative;
    background: transparent;
}
.inf .mdi-circle::before {
    content: ""!important;
}
.inf .v-carousel__controls__item.v-btn.v-btn--icon {
    background-color: #000; 
    width: 10px;
    height: 10px;
}
  
.inf .v-carousel__controls__item.v-btn.v-btn--icon.v-btn--active {
    background-color: #cac2c2; 
}

.inf .v-carousel__controls__item.v-btn.v-btn--icon:hover {
    background-color: black; 
    
}
</style>
<style scoped>

.item {
    display: block;
    height: 100%;
}
.hover-effect {
    position: relative;
    overflow: hidden;
}

.side-card {
    height: 300px;
    width: 300px;
    margin: 0 0 12px 0;
}

.center-card {
    height: 300px;
    width: 100%;
}

.image-content {
    border-radius: 4px;
    height: 100%;
    width: 100%;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.hover-icon {
    width: 42px;
    height: auto;
    margin-top: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.hover-effect:hover .hover-icon {
    opacity: 1;
}

.hover-effect:hover .overlay {
    opacity: 1;
}

.cu-ti {
    padding: 12px;
    text-align: center;
}

.cu-h-info {
    height: 612px;
}

.mid-cu {
    font-size: 24px;
    text-align: center;
    margin-top: 8px;
}

.button-section {
    margin-top: 20px;
}

.custom-button {
    background: transparent !important;
    border: 1px solid #ccc;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    font-weight: bold;
    padding: 20px 16px !important;
    width: 180px;
}

.custom-button-active {
    background: rgba(177, 189, 82, 1) !important;
    border-color: rgba(177, 189, 82, 1) !important;
}

.custom-button-text-active {
    color: #fff !important;
}

.button-icon {
    width: 20px;
    height: auto;
    margin-left: 5px;
    opacity: 0.7;
}

.button-icon-active {
    opacity: 1;
    filter: brightness(0) invert(1);
}

.button-icon-dark {
    filter: invert(1) brightness(2);
}

@media (min-width: 1024px) and (max-width: 1263px) {
  

  .side-card {
        height: 450px;
        width: 100%;
        margin-bottom: 16px;
    }
  
  }

  .card {
    margin-bottom: 20px;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}


.more_time {
    color: #979797;
    font-size: 13px;
    text-align: center;
}

.w-100 {
    width: 100%;
}

.scroll-horizontal {
    width: 100%; 
    padding-bottom: 8px;
    overflow-x: scroll; 
    overflow-y: hidden; 
    white-space: nowrap; 
    scrollbar-width: thin; 
    scrollbar-color: #a0a0a0 #ecf0f1;
}

/* .scroll-horizontal::-webkit-scrollbar {
    display: ;
} */

.scroll-horizontal::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 8px; 
}

.scroll-horizontal::-webkit-scrollbar-track {
    background: #ecf0f1; 
}

</style>
